import styles from './checklist.module.scss';
import parse from 'html-react-parser';
import { techDueDiligenceState } from '../../tech-due-diligence.state';

const Checklist = () => {
  const { title, text, cards } = techDueDiligenceState.checklist;

  return (
    <div className={styles.container}>
      <section className={styles.section}>
        <div className={styles.section__head}>
          <h2 className={styles.section__head__title}>{parse(title)}</h2>
          <div className={styles.section__head__description}>{text}</div>
        </div>

        <div className={styles.section__cards}>
          {cards.map((card) => (
            <div key={card.order} className={styles.section__cards__order}>
              <div className={styles.section__cards__order__item}>{card.order}</div>

              <div className={`${styles.section__card} ${card.linkUrl ? styles.section__card_link : ''}`}>
                <div className={styles.section__card_head}>
                  <div className={styles.section__card__order__title}>{card.order}</div>
                  <h4 className={styles.section__subtitle}>{card.title}</h4>
                </div>

                <div className={styles.section__text}>{card.text}</div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
};

export default Checklist;
